import { baseApi } from "api/BaseApi";

import { AdminPolicyLetter } from "./policies.types";

const POLICIES_BASE_URL = "publish/policies";

const adminPoliciesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listAllPolicies: build.query<AdminPolicyLetter[], void>({
      query: () => `${POLICIES_BASE_URL}/list_all/`,
      providesTags: ["POLICIES"],
    }),

    deletePolicy: build.mutation<void, number>({
      query: (policyId) => ({
        url: `${POLICIES_BASE_URL}/${policyId}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["POLICIES"],
    }),
  }),

  overrideExisting: false,
});

export const { useListAllPoliciesQuery, useDeletePolicyMutation } =
  adminPoliciesApi;
